import {
  GET_ALL_INTERESTS_SUCCESS,
  ERROR,
  ADD_INTERESTS_DATA_SUCCESS,
  DELETE_INTERESTS_BY_ID_SUCCESS,
  EDIT_INTERESTS_DATA_SUCCESS,
  REFRESH_INTERESTLIST,
  CREATE_LOAN_SUCCESS,
  UPDATE_LOAN_SUCCESS,
  GET_ALL_DISBURSMENT_REPORTS_SUCCESS,
  GET_ALL_PRODUCT_REPORTS_SUCCESS,
} from "../action_Types";

const initialState = {
  data: null,
  message: "",
  error: false,
  addData: null,
  allLoan: null,
  newallLoan: null,
  updateData: false,
  productUpdatedData: null,
  loanDisbursmentDataReports: [],
  loader: false,
};

const interestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "loader":
      return {
        ...state,
        loader: true,
      };

    case GET_ALL_INTERESTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: false,
        update: true,
        loader: false,
      };

    case GET_ALL_DISBURSMENT_REPORTS_SUCCESS:
      return {
        ...state,
        loanDisbursmentDataReports: action.payload.data,
        status: action.payload.status,
        error: false,
        update: true,
        loader: false,
      };
    case GET_ALL_PRODUCT_REPORTS_SUCCESS:
      return {
        ...state,
        productloanReports: action.payload.data,
        status: action.payload.status,
        error: false,
        update: true,
        loader: false,
      };

    case ADD_INTERESTS_DATA_SUCCESS:
      return {
        ...state,
        addData: action.payload,
        error: false,
        loader: false,
      };

    case REFRESH_INTERESTLIST:
      return {
        ...state,
        addData: null,
        error: false,
      };
    case EDIT_INTERESTS_DATA_SUCCESS:
      return {
        ...state,
        updateData: true,
        productUpdatedData: action.payload,
        error: false,
      };
    case DELETE_INTERESTS_BY_ID_SUCCESS:
      return {
        ...state,
        addData: true,
        error: false,
      };
    case CREATE_LOAN_SUCCESS:
      return {
        ...state,
        allLoan: action.payload,
        error: false,
      };
    case UPDATE_LOAN_SUCCESS:
      return {
        ...state,
        newallLoan: action.payload,
        error: false,
      };
    case ERROR:
      return {
        ...state,
        error: true,
        message: action.payload,
      };
    default:
      return state;
  }
};

export default interestsReducer;
